import React from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../../config/theme';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope
} from 'react-icons/fa';

const Footer = () => {
  const footerContainerStyles = {
    backgroundColor: theme.colors.gray[900],
    color: theme.colors.gray[300],
    paddingTop: '100px', 
    paddingBottom: theme.spacing.xl,
    marginTop: 'auto',
  };

  const gridStyles = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: theme.spacing['2xl'],
    maxWidth: '1200px',
    margin: '0 auto',
    padding: `0 ${theme.spacing.xl}`,
  };

  const columnHeadingStyles = {
    color: theme.colors.white,
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
    marginBottom: theme.spacing.lg,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  };

  const listStyles = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.md,
  };

  const linkStyles = {
    color: theme.colors.gray[400],
    textDecoration: 'none',
    transition: theme.transitions.base,
    display: 'inline-block',
  };

  const handleLinkHover = (e, isHovering) => {
    e.target.style.color = isHovering ? theme.colors.primary.light : theme.colors.gray[400];
    e.target.style.transform = isHovering ? 'translateX(4px)' : 'translateX(0)';
  };

  const logoStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
    marginBottom: theme.spacing.md,
  };

  const logoTextStyles = {
    fontSize: theme.typography.fontSize['2xl'],
    fontWeight: theme.typography.fontWeight.bold,
    background: `linear-gradient(135deg, ${theme.colors.primary.light} 0%, ${theme.colors.primary.main} 100%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    letterSpacing: '-0.5px',
  };

  const socialContainerStyles = {
    display: 'flex',
    gap: theme.spacing.md,
    marginTop: theme.spacing.xl,
  };

  const socialIconStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: theme.colors.white,
    textDecoration: 'none',
    transition: theme.transitions.base,
  };

  const handleSocialHover = (e, isHovering) => {
    e.currentTarget.style.backgroundColor = isHovering ? theme.colors.primary.main : 'rgba(255, 255, 255, 0.1)';
    e.currentTarget.style.transform = isHovering ? 'translateY(-3px)' : 'translateY(0)';
  };

  const contactItemStyles = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing.md,
    color: theme.colors.gray[400],
    lineHeight: 1.6,
  };

  const bottomBarStyles = {
    borderTop: `1px solid rgba(255, 255, 255, 0.1)`,
    marginTop: theme.spacing['4xl'],
    paddingTop: theme.spacing.xl,
    paddingBottom: 0,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    paddingLeft: theme.spacing.xl,
    paddingRight: theme.spacing.xl,
    fontSize: theme.typography.fontSize.sm,
  };

  return (
    <footer style={footerContainerStyles}>
      <div style={gridStyles}>
        
        {/* Brand Column */}
        <div>
          <div style={logoStyles}>
            <img 
              src="/images/logo.png" 
              alt="AlarcTrade Logo" 
              style={{ 
                height: '38px',
                width: 'auto', 
                objectFit: 'contain' 
              }} 
            />
            <span style={logoTextStyles}>AlarcTrade</span>
          </div>
          <p style={{ color: theme.colors.gray[400], lineHeight: 1.6, marginTop: theme.spacing.md }}>
            Your one-stop destination for premium products from top sellers worldwide. 
            Quality assured, prices guaranteed.
          </p>
        </div>

        {/* Quick Links Column */}
        <div>
          <h3 style={columnHeadingStyles}>Quick Links</h3>
          <ul style={listStyles}>
            <li>
              <Link to="/" style={linkStyles} onMouseEnter={(e) => handleLinkHover(e, true)} onMouseLeave={(e) => handleLinkHover(e, false)}>Home</Link>
            </li>
            <li>
              <Link to="/products" style={linkStyles} onMouseEnter={(e) => handleLinkHover(e, true)} onMouseLeave={(e) => handleLinkHover(e, false)}>All Products</Link>
            </li>
            <li>
              <Link to="/register" style={linkStyles} onMouseEnter={(e) => handleLinkHover(e, true)} onMouseLeave={(e) => handleLinkHover(e, false)}>Become a Seller</Link>
            </li>
          </ul>
        </div>

        {/* Customer Service Column */}
        <div>
          <h3 style={columnHeadingStyles}>Customer Service</h3>
          <ul style={listStyles}>
            <li>
              <Link to="/about" style={linkStyles} onMouseEnter={(e) => handleLinkHover(e, true)} onMouseLeave={(e) => handleLinkHover(e, false)}>About Us</Link>
            </li>
            <li>
              <Link to="/contact" style={linkStyles} onMouseEnter={(e) => handleLinkHover(e, true)} onMouseLeave={(e) => handleLinkHover(e, false)}>Contact</Link>
            </li>
            <li>
              <Link to="/terms" style={linkStyles} onMouseEnter={(e) => handleLinkHover(e, true)} onMouseLeave={(e) => handleLinkHover(e, false)}>Terms and Services</Link>
            </li>
            <li>
              <Link to="/privacy-policy" style={linkStyles} onMouseEnter={(e) => handleLinkHover(e, true)} onMouseLeave={(e) => handleLinkHover(e, false)}>Privacy Policy</Link>
            </li>
            <li>
              <Link to="/refund-policy" style={linkStyles} onMouseEnter={(e) => handleLinkHover(e, true)} onMouseLeave={(e) => handleLinkHover(e, false)}>Refund & Returns</Link>
            </li>
          </ul>
        </div>

        {/* Contact Column */}
        <div>
          <h3 style={columnHeadingStyles}>Contact Us</h3>
          
          {/* Restored the gap to lg */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.lg }}>
            
            <div style={contactItemStyles}>
              <FaMapMarkerAlt size={20} color={theme.colors.primary.main} style={{ marginTop: '2px' }} />
              <span> C/O KAWOSHE ACHUMI, DOPN<br />
                        CHEKIYE, BLOCK 5.<br /> AGASA 4TH MILE, DIMAPUR<br />
                        797115</span>
            </div>
            
            {/* Added a larger negative margin to pull just the email up */}
            <div style={{ ...contactItemStyles, marginTop: '-16px' }}>
              <FaEnvelope size={18} color={theme.colors.primary.main} style={{ marginTop: '2px' }} />
              <a 
                href="mailto:contact@alarctrade.com" 
                style={{ 
                  color: theme.colors.gray[400], 
                  textDecoration: 'none',
                  transition: theme.transitions.base
                }}
                onMouseEnter={(e) => e.target.style.color = theme.colors.primary.light}
                onMouseLeave={(e) => e.target.style.color = theme.colors.gray[400]}
              >
                contact@alarctrade.com
              </a>
            </div>
            
          </div>
        </div>

      </div>

      {/* Bottom Bar */}
      <div style={bottomBarStyles}>
        <p style={{ margin: 0 }}>&copy; {new Date().getFullYear()} AlarcTrade. All rights reserved.</p>
        <div style={{ display: 'flex', gap: theme.spacing.lg, marginTop: theme.spacing.sm }}>
          <Link to="/terms" style={{ ...linkStyles, fontSize: theme.typography.fontSize.sm }}>Terms of Service</Link>
          <Link to="/privacy-policy" style={{ ...linkStyles, fontSize: theme.typography.fontSize.sm }}>Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;